<template>
<div>
  <div>
    <h3> Co-Trustors </h3>
    <v-layout row>
    <v-flex md12>
    <v-expansion-panel v-model="panel">
    
    <CoTrustor v-for="cotrustor in cotrustors" 
    :cotrustor="cotrustor" 
    v-on:delete="onDeleteItem($event)"
    :key="cotrustor.id" />
    </v-expansion-panel>
    </v-flex>
    </v-layout>
  </div>
<span>
  <v-btn data-btn="add-trustor"  @click="addTrustor()" flat icon color="green">
    <v-icon>person_add</v-icon>
  </v-btn>
  Add trustor
</span>
</div>
</template>

<script>
import CoTrustor from "./CoTrustor.vue";

export default {
  data: () => ({
    panel: [true]
  }),
  components: {
    CoTrustor
  },
  props: ["cotrustors"],
  computed: {},
  methods: {
    addTrustor() {
      console.log("Adding trustor");
      this.cotrustors.push({ id: this.cotrustors.length + 1 });
    },
    onDeleteItem(cotrustor) {
      this.$emit("deleteTrustor", cotrustor);
    },
  }
};
</script>

<style>
</style>
